import { ref } from 'vue'

const handleBeforeLogout = ref<(() => boolean) | null>(null)

export function useBeforeLogout() {
  const setHandleBeforeLogout = (callback: (() => boolean) | null) => {
    handleBeforeLogout.value = callback
  }

  const unsetHandleBeforeLogout = () => {
    handleBeforeLogout.value = null
  }
  return { setHandleBeforeLogout, unsetHandleBeforeLogout, handleBeforeLogout }
}
